import React from 'react'
import DataTable from 'react-data-table-component'

const DatatableMasterChapters = (props) => {

    const columns = [
        {
            width: '23%',
            name: "Standard Akreditasi",
            selector: (row) => row?.standards_accreditation.Nama,
        },
        {
            width: "10%",
            name: "Singkatan",
            selector: (row) => row.Singkatan,
        },
        {
            width: '30%',
            name: "Deskripsi",
            selector: (row) => row.Deskripsi,
        },
        {
            width: "20%",
            name: "Created At",
            selector: (row) => row.createdAt,
        },
        {
            width: "20%",
            name: "Updated At",
            selector: (row) => row.updatedAt,
        },
    ]

    return (
        <>
            <h5 className="card-title">Daftar Bab</h5>
            <DataTable
                columns={columns}
                data={props.datas}
                pagination
                fixedHeader
                highlightOnHover
                subHeader
                subHeaderComponent={
                    <input
                        type="text"
                        placeholder="Search"
                        className='w-50 form-control m-3'
                        values={props.search}
                        onChange={(e) => props.handleChangeSearch(e.target.value)}
                    />
                }
                subHeaderAlign="center"
            />
        </>
    )
}

export default DatatableMasterChapters
